import React, { useState } from 'react';
import { Col, Row, Segmented } from 'antd';
import CustomerBaseChart from './CustomerBaseChart';

const CustomerBaseChartContainer = ({data}) => {
    const [segmentedValue, setSegmentedValue] = useState(1);

    const segmentedOptions = [
        {label: 'Adet Bazlı', value: 1}, 
        {label: 'Fiyat Bazlı', value: 2},
        {label: 'Olumlu', value: 3},
        {label: 'Olumsuz', value: 4},
        {label: 'Bekleyen', value: 5}
    ];

    return(
        <React.Fragment>
            <Row justify={'center'} align={'center'}>
                <Segmented options={segmentedOptions} value={segmentedValue} onChange={setSegmentedValue}/>
            </Row>
            <Row justify={'center'} style={{marginTop: '8px'}}>
                <Col span={18}>
                    <CustomerBaseChart chartData={data} chartValue={segmentedValue}/>
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default CustomerBaseChartContainer;